import type {ComponentProps, ImgHTMLAttributes} from 'react';

import Button from '@/components/common/Button';

// `onClick` belongs to the "Change" button, not the image, so it is taken from
// Button's props and kept out of the props spread onto <img>.
type ImageViewerProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'onClick'> &
  Pick<ComponentProps<typeof Button>, 'onClick'>;

const ImageViewer = ({onClick, ...imageProps}: ImageViewerProps) => {
  return (
    <>
      <label>{imageProps.alt}</label>
      <img {...imageProps} style={{width: '30%'}} alt={imageProps.alt} />
      <div className="flex justify-end">
        <Button variant="ghost" onClick={onClick}>
          Change {imageProps.alt}
        </Button>
      </div>
      <hr />
    </>
  );
};

export default ImageViewer;
